export default class Composto {

  constructor() {
    this.id = 0;
    this.nome = "";
  }
}
